// Paths to files in /public, respecting PUBLIC_URL.
export const publicUrl = (path) => `${process.env.PUBLIC_URL}/${path}`;

export const asset = (name) => publicUrl(`assets/${name}`);

export const LOGO = asset('daalchini-logo.webp');

// White "TIMES" for dark/purple backgrounds, purple "TIMES" for light/yellow ones.
export const TIMES_PRIME_LOGO = asset('times-prime.webp');
export const TIMES_PRIME_LOGO_PURPLE = asset('times-prime-purple.webp');
